// extracted by mini-css-extract-plugin
export default {"cardsList":"CardsList_cardsList__8jAMU"};